<template lang="pug">
  // this component should not be used by it's own
  // it's meant to be extended
  .page
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'Page',
    computed: {
        areas() {
            let areas = {};
            if (this.sections && this.sections.length) {
                this.sections.map(section => {
                    const key = section.area || 'main';
                    if (!areas[key]) areas[key] = [];
                    areas[key].push(section);
                });
            }
            return areas;
        },
        ...mapGetters({
            sections: 'sections'
        })
    }
};
</script>
